<template>
  <section>
    <div class="titulo">
      <div class="margem container">
        <div class="cabecalho-pagina-visitantes">
          <div class="m-icone esquerda">
            <a @click="$router.back()" style="cursor: pointer" class="icone-voltar m-d"></a>
          </div>
          <h2>Todos os visitantes</h2>
        </div>
      </div>
    </div>

    <div class="margem container">
      <div class="bloco margem bloco-lista-visitantes">
        <div class="filtros-visitantes">
          <div>
            <label for="filtro-nome">Pesquisar por nome</label>
            <input id="filtro-nome" v-model="filtroNome" type="text" placeholder="Nome do visitante" @input="pesquisar" />
          </div>
          <div>
            <label for="filtro-empresa">Pesquisar por empresa</label>
            <input id="filtro-empresa" v-model="filtroEmpresa" type="text" placeholder="Empresa" @input="aplicarFiltroEmpresa" />
          </div>
        </div>

        <div class="tabela-visitantes-scroll">
          <table class="tabela tabela-visitantes">
            <thead>
              <tr>
                <th class="th-foto">Foto</th>
                <th>Nome</th>
                <th>Empresa</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in visitantesFiltrados" :key="item.id">
                <td class="td-foto">
                  <img v-if="item.fotoUrl" :src="item.fotoUrl" alt="Foto do visitante" class="foto-visitante" />
                  <div v-else class="foto-visitante-placeholder">
                    <i class="fa-solid fa-user"></i>
                  </div>
                </td>
                <td class="td-texto">{{ item.nomeCompleto || "—" }}</td>
                <td class="td-texto">{{ item.empresa || "—" }}</td>
              </tr>
            </tbody>
            <tbody v-if="!carregando && visitantesFiltrados.length === 0">
              <tr>
                <td colspan="3" class="celula-vazia">Nenhum visitante encontrado.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div v-if="lastPage > 1" class="paginacao-lista">
          <button type="button" @click="buscar(page - 1)" :disabled="page <= 1 || carregando">Anterior</button>
          <span class="paginacao-lista-info">Página {{ page }} de {{ lastPage }}</span>
          <button type="button" @click="buscar(page + 1)" :disabled="page >= lastPage || carregando">Próxima</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { createToaster } from "@meforma/vue-toaster";
import visitanteService from "@/services/visitante-service";

const toaster = createToaster({ position: "top-right" });

export default {
  name: "ListaVisitantesView",

  data() {
    return {
      visitantes: [],
      visitantesFiltrados: [],
      filtroNome: "",
      filtroEmpresa: "",
      page: 1,
      lastPage: 1,
      carregando: false,
      debounce: null,
    };
  },

  created() {
    this.buscar(1);
  },

  methods: {
    aplicarFiltroEmpresa() {
      const termo = this.filtroEmpresa.trim().toLowerCase();
      if (!termo) {
        this.visitantesFiltrados = [...this.visitantes];
        return;
      }
      this.visitantesFiltrados = this.visitantes.filter((v) =>
        String(v.empresa || "").toLowerCase().includes(termo)
      );
    },

    pesquisar() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.buscar(1);
      }, 400);
    },

    async buscar(p = 1) {
      if (p < 1) return;
      this.carregando = true;
      try {
        const res = await visitanteService.listarTodos({
          page: p,
          search: this.filtroNome,
        });
        this.visitantes = res.data || [];
        this.page = res.current_page ?? p;
        this.lastPage = res.last_page ?? 1;
        this.aplicarFiltroEmpresa();
      } catch (err) {
        console.error(err);
        this.visitantes = [];
        this.visitantesFiltrados = [];
        toaster.show("Erro ao carregar visitantes.", { type: "error" });
      } finally {
        this.carregando = false;
      }
    },
  },
};
</script>

<style scoped>
.cabecalho-pagina-visitantes {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.bloco-lista-visitantes {
  border-radius: 12px;
  border: 1px solid var(--cor-separador);
  background: var(--cor-bg);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.filtros-visitantes {
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  gap: 0.85rem 1.1rem;
  margin-bottom: 1rem;
}

.filtros-visitantes label {
  display: block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cor-fonte-fraca);
  margin-bottom: 0.35rem;
}

.filtros-visitantes input {
  width: 100%;
  border-radius: 8px;
  border: 1px solid var(--cor-separador);
  padding: 0.55rem 0.65rem;
  font-size: 0.9rem;
  background: var(--cor-bg);
}

.filtros-visitantes input:focus {
  outline: none;
  border-color: hsl(var(--h) var(--s) var(--l) / 0.45);
  box-shadow: 0 0 0 2px hsl(var(--h) var(--s) var(--l) / 0.12);
}

.tabela-visitantes-scroll {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  margin: 0 -0.25rem;
}

.tabela-visitantes {
  min-width: 520px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.tabela-visitantes thead th {
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--cor-fonte-fraca);
  font-weight: 700;
  padding: 0.65rem 0.5rem;
  border-bottom: 1px solid var(--cor-separador);
  background: transparent;
}

.th-foto,
.td-foto {
  text-align: center;
  width: 4.5rem;
}

.tabela-visitantes tbody td {
  padding: 0.75rem 0.5rem;
  vertical-align: middle;
  border-bottom: 1px solid var(--cor-separador);
  font-size: 0.92rem;
}

.td-texto {
  text-align: left;
}

.tabela-visitantes tbody tr:last-child td {
  border-bottom: none;
}

.celula-vazia {
  text-align: center;
  color: var(--cor-fonte-fraca);
  font-size: 0.9rem;
  padding: 1.5rem 0.5rem !important;
}

.paginacao-lista {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1rem;
  margin-top: 1.15rem;
  padding-top: 1rem;
  border-top: 1px solid var(--cor-separador);
}

.paginacao-lista-info {
  font-size: 0.9rem;
  color: var(--cor-fonte-fraca);
}

.foto-visitante,
.foto-visitante-placeholder {
  width: 52px;
  height: 52px;
  border-radius: 50%;
}

.foto-visitante {
  object-fit: cover;
  border: 1px solid var(--cor-separador);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.foto-visitante-placeholder {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  background: var(--cor-cinza);
  border: 1px solid var(--cor-separador);
  color: var(--cor-fonte-fraca);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

@media (max-width: 640px) {
  .filtros-visitantes {
    grid-template-columns: 1fr;
  }
}
</style>
